import React from 'react';
import { Container, Stack, useTheme } from '@mui/system';
import { Typography } from '@mui/material';

const fuzzy = [
  {
    question: `What is spelling leniency (aka the fuzzy algo)?`,
    answer: `It is our system for accepting non-perfectly typed answers`,
  },
  {
    question: `What is the motivation behind this feature?`,
    answer: `Typing and spelling is a very big part of PAR. Frankly, it is the mechanical skill that makes this game feel like a sport.
    
    Every once in a while, even a great typist or speller will run into a question where they type out an answer ALMOST perfectly. Attempting to correct the mistake could mean precious seconds lost, sometimes even costing the game. It can be argued the "purest" form of the game would always require perfectly typed answer, but the player experience can be pure frustration. It just leaves a very bad taste when it happens, overshadowing a lot of the good moments.
    `,
  },
  {
    question: `Are there rules around the leniency?`,
    answer: `Yes:

    - Only applies to answers 9 letters or more
    - Prepended articles do not count towards the minimum letter requirement. For example: "The Monkees" requires exact spelling
    - Numbers and roman numerals require exact matches.
    - Numbers and roman numerals that are a part of an answer don't count towards the min. letter requirement. For example, "Nicholas II" requires exact spelling.
    - First letter has to be an exact match
    - If all letters are revealed except the last, exact match is required
    `,
  },
  {
    question: `What is PRECISION?`,
    answer: `PRECISION is the system we use to essentially grade how close your spelling was. There are 4 levels:

    - PRISTINE: Perfectly typed answers on the first try. Gets a -1 bonus.
    - POISED: Very acceptable answers. No penalty and no bonus.
    - PASSABLE: Acceptable answers. Gets a +1 penalty
    - PANICKY: Barely acceptable answers. Get a +2 penalty
    `,
  },
  {
    question: `How does the algorithm work? Is it fair?`,
    answer: `We aren't going to spill the secrets of the algorithm, but here are some insights:

    - We use a combination of edit distance and phonetic methods
    - The longer the word, the more lenient it is
    - Typos such as letter swaps are more lenient than omitting a letter or adding an extra one
    - Answers that contain multiple words have each word scored individually and then the entire answer as a whole
    - Simple words like articles and prepositions are more lenient

    Is it fair? We shall see. This is more of an art than a science. We can't just use an off-the-shelf algorithm because trivia has very specific ideas of what should or should not be acceptable. You will see some egregious "Panickies" or at times a "Passable" when it should probably be a "Poised". Or "decimeter" might be accepted for "decameter". It is very difficult to distinguish mistake vs intent, the system is nowhere near perfect. But these instances are rare enough we are just going to roll with it because in the end, it makes for a much better playing experience. 
    `,
  },
];

export const SpellingLeniency = () => {
  return (
    <Container sx={{ paddingBottom: 10 }}>
      <Typography variant="h4" textAlign={'center'} mb={4}>
        Spelling Leniency and Precision
      </Typography>
      {fuzzy.map((o) => (
        <>
          <Stack direction={'row'} spacing={1} mt={2}>
            <Typography color="success.main">Q:</Typography>
            <Typography variant="body1">{o.question}</Typography>
          </Stack>
          <Stack direction={'row'} spacing={1} mt={1} mb={1}>
            <Typography color="ranked.main">A:</Typography>
            <Typography variant="body1" sx={{ whiteSpace: 'pre-line' }}>
              {o.answer}
            </Typography>
          </Stack>
        </>
      ))}
    </Container>
  );
};
